/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard React components
import MasterCard from "examples/Cards/MasterCard";
// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Billing page components
import PaymentMethod from "layouts/billing/components/PaymentMethod";
import Invoices from "layouts/billing/components/Invoices";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";
import CreditBalance from "./components/CreditBalance";
import { Button, Card, Input } from "@mui/material";
import { useEffect, useState } from "react";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import { getAuth } from "firebase/auth";
import { UserData, GetUserData, ProccessDeposit, ProccessWithdrawal } from "Api";
import { Select, Spin, message } from "antd";
import { Coin, getCoins } from "utils/coins";
import VuiTypography from "components/VuiTypography";
import { sendMailForTransaction } from "utils/Mailer";

function Billing() {
  const [userData, setData] = useState(UserData.emtpy());
  const [loading, setLoading] = useState(true)
  const [coins, setCoins] = useState([])
  const [selCoin, setSelCoin] = useState(null)
  const [amount, setAmount] = useState(0)
  const [show, setShow] = useState(false)
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    const auth = getAuth();
   const sub = auth.onAuthStateChanged((user) => {
    if(user){
        fetchData(user.uid);
    }
   })

   return () =>{
    sub()
   }
  }, []);

    async function copyAddress(){
      try {
          await navigator.clipboard.writeText(selCoin.address);
          setCopied(true);
          const a = (amount / selCoin.price).toFixed(3);
          message.success("Address copied to clipboard, " + "Please send "+a+ " " +selCoin.symbol+
          " to this address to complete your deposit", 10);
      } catch (error) {
          message.error(error.message);
          setCopied(true);
      }
  }

  async function deposit(){
    setLoading(true)
   try {
    await ProccessDeposit(userData.uid, amount, selCoin.address, selCoin.symbol)
    var {email, displayName} = getAuth().currentUser;
    sendMailForTransaction(email, displayName, amount, "Deposit", "Pending")
    message.info("Your deposit is been processed");
    setShow(false)
   } catch (error) {
    message.error("error processing your deposit")
    console.log(error)
   }
   setLoading(false)
  }
  
    async function  fetchData (uid) {
      console.log("fetched data");
      const data = await GetUserData(uid);
      const c = await getCoins()
      setCoins(c)
      setData(data);
     if (data) {
       setLoading(false);
     }
    }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Spin spinning={loading}>
      <VuiBox mt={4}  style={{
       minHeight: "65vh"
      }}>
        <VuiBox mb={1.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7} xl={8}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} xl={6}>
                  <CreditBalance balance={userData.balance}/>
                </Grid> 
                <Grid item xs={12} md={12} xl={6}>
                  {show?
                  <div>
                     <VuiBox display="flex" >
               <VuiInput value={selCoin?.address}  className="me-2"/>
                    <VuiButton 
                     color="primary"
                     onClick={copyAddress}
                    >Copy Address</VuiButton>
                    </VuiBox>
                    <p className="mt-2 h6 text-primary">
                     <span className="text-white opacity-75">{"Amount: "}</span>{selCoin ? (amount / selCoin?.price)?.toFixed(3) : ""} <span> {selCoin?.symbol}</span>
                    </p>
                    <p className="text-white opacity-50 h6 mb-4">by clicking Confirm Deposit you agree that you have transfered {selCoin ? (amount / selCoin?.price)?.toFixed(3) : ""} {selCoin?.symbol} to the address above</p>
                    <VuiBox display="flex" >
                    <VuiButton 
                    className="w-50 me-2"
                     color="dark"
                     onClick={() =>{ setShow(false)
                     }}
                    >Cancel</VuiButton>
                    <VuiButton
                    disabled={loading || !copied}
                    className="w-50 ms-2"
                     color="primary"
                     onClick={deposit}
                    >Confirm Deposit</VuiButton>
                    </VuiBox>
                  </div> :
                    <div>
                  <VuiBox display="flex" >
                    <Select 
                    placeholder="Select Payment coin"
                    onChange={(v) => setSelCoin(coins[v])}
                    className="mb-2 w-75">
                      {coins.map((coin, index) => <Select.Option value={index}>
                        {coin.symbol}
                      </Select.Option>)}
                    </Select>
                    <p className="ms-3 text-white">
                     {selCoin ? (amount / selCoin?.price)?.toFixed(3) : ""}
                    </p>
                    <p className="ms-3 text-white">{selCoin?.symbol}</p>
                  </VuiBox>
                  <VuiBox display="flex" >
               <VuiInput onChange={(c) => setAmount(c.target.value)} className="me-2" prefix="$" placeholder="Amount to deposit" type="number"/>
                    <VuiButton 
                     color="primary"
                     onClick={() =>{
                      if(selCoin && amount > 0) setShow(true)
                     }}
                    >Deposit</VuiButton>
                    </VuiBox>
                    </div>}
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      </Spin>
      <Footer />
    </DashboardLayout>
  );
}

function Billing2() {

  const [userData, setData] = useState(UserData.emtpy());
  const [loading, setLoading] = useState(true)
  const [coins, setCoins] = useState([])
  const [selCoin, setSelCoin] = useState(null)
  const [amount, setAmount] = useState(0)
  const [show, setShow] = useState(false)
  const [copied, setCopied] = useState(false);
  const [address, setAddress] = useState("")

    useEffect(() => {
      const auth = getAuth();
     const sub = auth.onAuthStateChanged((user) => {
      if(user){
          fetchData(user.uid);
      }
     })
  
     return () =>{
      sub()
     }
    }, []);

  async function deposit(){
    setLoading(true)
   try {
    await ProccessWithdrawal(userData.uid, amount, address, selCoin.symbol)
    var {email, displayName} = getAuth().currentUser;
    sendMailForTransaction(email, displayName, amount, "Withdrawal", "Pending")
    message.info("Your withdrawal is been processed");
    setShow(false)
    fetchData(userData.uid);
   } catch (error) {
    message.error("error processing your withdrawal")
    console.log(error)
   }
   setLoading(false)
  }
  
    async function  fetchData (uid) {
      setLoading(true)
      console.log("fetched data");
      const data = await GetUserData(uid);
      const c = await getCoins()
      setCoins(c)
      setData(data);
     if (data) {
       setLoading(false);
     }
    }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Spin spinning={loading}>
      <VuiBox mt={4}  style={{
       minHeight: "65vh"
      }}>
        <VuiBox mb={1.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7} xl={8}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} xl={6}>
                  <CreditBalance balance={userData.balance}/>
                </Grid> 
                <Grid item xs={12} md={12} xl={6}>
                  {show?
                  <div>
               <VuiInput onChange={(c) => setAddress(c.target.value)} className="mb-3" placeholder="Paste wallet address here"/>
                    <VuiBox display="flex" >
                    <VuiButton 
                    className="w-50 me-2"
                     color="dark"
                     onClick={() =>{ setShow(false)
                     }}
                    >Cancel</VuiButton>
                    <VuiButton
                    disabled={loading}
                    className="w-50 ms-2"
                     color="primary"
                     onClick={deposit}
                    >Confirm Withdrawal</VuiButton>
                    </VuiBox>
                  </div> :
                    <div>
                  <VuiBox display="flex" >
                    <Select 
                    placeholder="Select Payment coin"
                    onChange={(v) => setSelCoin(coins[v])}
                    className="mb-2 w-75">
                      {coins.map((coin, index) => <Select.Option value={index}>
                        {coin.symbol}
                      </Select.Option>)}
                    </Select>
                    <p className="ms-3 text-white">
                     {selCoin ? (amount / selCoin?.price)?.toFixed(3) : ""}
                    </p>
                    <p className="ms-3 text-white">{selCoin?.symbol}</p>
                  </VuiBox>
                  <VuiBox display="flex" >
               <VuiInput onChange={(c) => setAmount(c.target.value)} className="me-2" prefix="$" placeholder="Amount to withdraw" type="number"/>
                    <VuiButton 
                     color="primary"
                     onClick={() =>{
                      if(selCoin && amount <= userData.balance) setShow(true)
                     }}
                    >Withdraw</VuiButton>
                    </VuiBox>
                    </div>}
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      </Spin>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
export {Billing2};
